<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text style="max-height: calc(100vh - 180px); overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <label class="label-input">Settings</label>
          <v-row>
            <v-col cols="12" md="6">
              <div class="d-flex align-center">
                <input
                  type="color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['background-section'].color"
                  @input="e => (fields['background-section'].color = e.target.value)"
                />
                <v-text-field v-model="fields['background-section'].color" label="Background Section" />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex align-center">
                <input
                  type="color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields.textColor"
                  @input="e => (fields.textColor = e.target.value)"
                />
                <v-text-field v-model="fields.textColor" label="Text Color" />
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field v-model.number="fields.listPost.colPerView" type="number" min="1" label="Cols Desktop" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.padding.top" label="Top Padding" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <label class="label-input">Title Post</label>
          <ckeditor :editor="editor" v-model="fields.titlePost" :config="editorConfig" />
        </div>

        <div>
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Posts</label>
            <v-btn small text color="primary" @click="handleAddPost">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Post</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(post, index) in fields.listPost.listItem" :key="index">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center" style="width: 100%">
                  <span>Post {{ index + 1 }}</span>
                  <v-btn icon @click.stop="handleRemovePost(index)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="6">
                    <label class="label-sub">Outher Avatar</label>
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, index, 'outherAvatar')"
                      :image="{ imageSrc: post.outherAvatar }"
                      :height="`160`"
                      :typeUpload="'image'"
                      @callbackDelete="() => handleClearImage(index, 'outherAvatar')"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <label class="label-sub">Post Image</label>
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, index, 'postImage')"
                      :image="{ imageSrc: post.postImage }"
                      :height="`160`"
                      :typeUpload="'image'"
                      @callbackDelete="() => handleClearImage(index, 'postImage')"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="post.outherName" label="Outher Name" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="post.createdAt" label="Created At" />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <label class="label-sub">Post Text</label>
                    <v-textarea
                      v-model="post.postText"
                      outlined
                      auto-grow
                      rows="3"
                      placeholder="Nội dung bài đăng..."
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="post.reactionCount" label="Reaction Count" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="post.commentCount" label="Comment Count" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';

const defaultPost = () => ({
  outherName: 'John Doe',
  outherAvatar: '',
  createdAt: '6h ago',
  postImage: '',
  commentCount: '2',
  reactionCount: '67',
  postText: '',
});

export default {
  name: 'fb-post-03',
  components: { UploadImage },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'FB Post 03 Section',
        enableAnchor: false,
        textColor: '#000000',
        padding: {
          top: true,
          bottom: true,
        },
        'background-section': {
          color: '#f7eee7',
        },
        'container-content': {
          showStyle: false,
          background: '#ffffff',
        },
        container: {
          enableContainer: false,
        },
        titlePost: '',
        listPost: {
          colPerView: 3,
          listItem: [defaultPost()],
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
      padding: {
        ...this.fields.padding,
        ...(this.sectionEditor.sectionExtract.padding || {}),
      },
      'background-section': {
        ...this.fields['background-section'],
        ...(this.sectionEditor.sectionExtract['background-section'] || {}),
      },
      listPost: {
        colPerView: this.sectionEditor.sectionExtract.listPost?.colPerView || this.fields.listPost.colPerView || 3,
        listItem: this.normalizePosts(this.sectionEditor.sectionExtract.listPost?.listItem),
      },
    };
  },
  methods: {
    normalizePosts(posts) {
      if (!Array.isArray(posts) || posts.length === 0) return [defaultPost()];
      return posts.map(post => ({
        ...defaultPost(),
        ...post,
      }));
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        listPost: {
          ...this.fields.listPost,
          colPerView: Math.max(1, Number(this.fields.listPost.colPerView) || 1),
        },
      };
      const updateHtml = updateHtmlFromData.sectionFbPost03(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddPost() {
      this.fields.listPost.listItem.push(defaultPost());
    },
    handleRemovePost(index) {
      this.fields.listPost.listItem.splice(index, 1);
      if (this.fields.listPost.listItem.length === 0) {
        this.fields.listPost.listItem.push(defaultPost());
      }
    },
    handleUploadImage(obj, index, key) {
      this.fields.listPost.listItem[index][key] = obj?.imageSrc || '';
    },
    handleClearImage(index, key) {
      this.fields.listPost.listItem[index][key] = '';
    },
  },
};
</script>

<style scoped lang="scss">
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.label-sub {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0 0 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0 0 12px #0000000f;
}
</style>
